<div [formGroup]="form">
  <ng-container *ngFor="let item of [].constructor(codeLength); let index = index">
    <mat-form-field appearance="fill">
      <input
        #input
        matInput
        type="text"
        maxlength="1"
        pattern="\d*"
        (focus)="onFocus(input)"
        (mouseup)="$event.preventDefault()"
        (paste)="onPaste($event)"
        (keyup)="onKeyup($event, index)"
        [id]="'input' + index"
        [formControlName]="'input' + index"
        [attr.disabled]="disabled ? '' : null"
      >
    </mat-form-field>
    <span
      *ngIf="codeLength % 2 === 0 && index === codeLength / 2 - 1"
      class="dash mr-2"
    >-</span>
  </ng-container>
</div>